import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const TechHero = () => {
  const techStats = [
    { label: "Technologies Mastered", value: "15+", icon: "Code" },
    { label: "SLA Uptime", value: "99.99%", icon: "Zap" },
    { label: "Client Success", value: "100%", icon: "CheckCircle" },
    { label: "Engineering Heritage", value: "Elite", icon: "Award" }
  ];

  return (
    <section className="relative min-h-[80vh] bg-slate-950 flex items-center justify-center overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-64 h-64 bg-primary/5 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent/5 rounded-full blur-[120px]"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center pt-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-12"
        >
          <div className="inline-flex items-center space-x-2 bg-white/5 border border-white/10 text-white/60 px-4 py-2 rounded-full text-xs font-bold uppercase tracking-widest mb-8">
            <Icon name="Cpu" size={14} className="text-primary" />
            <span>Project Capability Matrix</span>
          </div>

          <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-white mb-8 leading-[1.05] tracking-tight">
            Any Stack.{' '}
            <span className="text-gradient bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent">
              Any Scale.
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-slate-400 max-w-4xl mx-auto leading-relaxed">
            From high-conversion E-commerce engines to complex SaaS architectures and native mobile apps.
            We leverage a world-class technology stack to deliver robust, enterprise-grade solutions
            for any digital challenge.
          </p>
        </motion.div>

        {/* Tech Stats Grid */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-16"
        >
          {techStats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.1 * index }}
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-8 hover:bg-white/10 transition-all duration-300 group"
            >
              <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-transform">
                <Icon name={stat.icon} size={24} className="text-primary" />
              </div>
              <h3 className="text-3xl font-black text-white mb-2">{stat.value}</h3>
              <p className="text-xs font-bold text-slate-500 uppercase tracking-widest">{stat.label}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TechHero;
